import {
  styled,
  AppBar as BaseAppBar,
  IconButton as BaseIconButton,
} from '@mui/material'
import { isGlobalworth } from 'config'
import { Link as BaseLink } from 'react-router-dom'
import { LogoTopbar as BaseLogo } from 'shared/assets'

export const StyledTopbar = styled(BaseAppBar)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  borderRadius: 0,
  height: '65px',
  [theme.breakpoints.down('sm')]: {
    height: '56px',
  },
}))

export const IconButton = styled(BaseIconButton)(({ theme }) => ({
  color: theme.palette.primary.contrastText,
}))

export const ButtonWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexGrow: 1,

  [theme.breakpoints.down('md')]: {
    '& svg': {
      fontSize: 24,
    },
  },
}))

export const Actions = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),

  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(0.5),
  },
}))

export const Link = styled(BaseLink)(({ theme }) => ({
  textDecoration: 'none',
  color: theme.palette.text.primary,
  backgroundColor: theme.palette.primary.main,
}))

export const Logo = styled(BaseLogo)({
  width: isGlobalworth ? 180 : 120,
  height: '40px',
  margin: isGlobalworth ? '0px -25px' : '0',
})
